import { alpha, Drawer, InputBase, List, Typography } from "@mui/material";
import styled, { css } from "styled-components";
import { theme } from "styles/mui-config";
import MuiAppBar from "@mui/material/AppBar";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

export const StyledDrawer = styled(Drawer)`
  width: ${(props) => props.$drawerWidth}px;
  flex-shrink: 0;
  & .MuiDrawer-paper {
    width: ${(props) => props.$drawerWidth}px;
    box-sizing: border-box;
    background-color: white;
  }
`;
////////////////////////////////////////
export const StyledAccordion = styled(Accordion)`
  background: transparent !important;
  box-shadow: none !important;
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
`;
export const StyledSetting = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
////////////////////////////////////////
export const StyledList = styled(List)`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  & div {
    color: white;
    padding: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    color: #a4a4a4;
    border-radius: 10px;
  }
`;
export const StyledListItemIcon = styled(ListItemIcon)`
  min-width: 33px !important;
`;

export const StyledListItemText = styled(ListItemText)`
  & span {
    font-size: 17px !important;
  }
`;

////////////////// Search /////////////////////
export const SearchBoxWrapper = styled.div`
  padding: ${theme.spacing(0, 2)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
`;

//////////////////////////////////////////
export const StyledInputBase = styled(InputBase)`
  color: inherit;
  & .MuiInputBase-input {
    padding: ${theme.spacing(1, 1, 1, 0)};
    color: gray !important;
    // vertical padding + font size from searchIcon
    // padding-right: calc(1em + +${theme.spacing(4)});
    padding-right: 20px;
    transition: 0.3s;
    width: 100% !important;
    &:hover {
      background-color: ${alpha(theme.palette.common.white, 0.3)};
    }
    &:focus {
      background-color: ${alpha(theme.palette.common.white, 0.3)};
    }
    ${theme.breakpoints.up("sm")}
  }
`;

//////////////////////////////////
export const StyledSearch = styled.div`
  min-width:250px;
  position: relative;
  border-radius: ${theme.shape.borderRadius}px;
  background-color: ${alpha(theme.palette.common.white, 0.2)};
  margin-left: 0;
  width: 100% !important;
  background: white;
  transition: 0.3s;
  border-radius: 14px;
  height: 55px;
  margin: 10px;
  ${theme.breakpoints.up("sm")} {
    margin-left: ${theme.spacing(1)};
    width: auto;
  }
  display: flex !important;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

/////////////////////////////////////
export const StyledTypo = styled(Typography)`
  flex-grow: 1;
  ${theme.breakpoints.down("sm")} {
    display: none;
  }
`;
///////////////////////////////////

export const StyledDrawerHeader = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: end;
  padding: ${theme.spacing(0, 1)};
  // necessary for content to be below app bar
  ${theme.mixins.toolbar}
  justify-content: flex-end;
  background:transparent;
`;
export const StyledProfile = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  padding: 20px;
  padding: 10px;
  box-sizing: border-box;
  padding-top: 0px;
  padding-bottom: 16px;
  & div {
    width: 60px;
    height: 68px;
    border-radius: 100%;
    // background: ${theme.palette.primary.main};
    display: flex;
    align-items: center;
    font-size: 30px;
    justify-content: center;
    & svg {
      width: 50px;
      height: 50px;
      color: white;
    }
    & img {
      width: 100%;
      height: 100%;
    }
  }
  & h3 {
    font-size: 16px;
    font-weight: normal;
    margin-right: 20px;
  }
`;

///////////////////////////////////
const isAppBarOpen = ({ open }) => {
  if (open) {
    return css`
      width: calc(100% - +${(props) => props.$drawerWidth}px) !important;
      margin-right: ${(props) => props.$drawerWidth}px !important;
      transition: ${theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      })} !important;
    `;
  }
};

export const StyledAppBar = styled(MuiAppBar)`
  transition: ${theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })} !important;
  box-shadow: none !important;
  background: white !important;
  padding-top: 20px;
  ${isAppBarOpen}
`;

///////////////////////////////////////////////
const isMainOpen = ({ open }) => {
  if (open) {
    return css`
      transition: ${theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      })};
      margin-right: 0;
    `;
  }
};
export const StyledMain = styled.main`
  flex-grow: 1;
  transition: ${theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  })};
  width: 100%;
  padding-top:40px;
  margin-right: -${(props) => props.$drawerWidth}px;
  ${isMainOpen}
`;

